import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useSettings } from '@/data/Settings';
import { transactionsCouponStatus } from 'integration/generated/transactions';
import useSWR from 'swr';

const DATA_KEY_COUPON_STATUS = 'CouponStatus';

export const useCouponStatus = (promotionId?: string) => {
	const { settings } = useSettings();
	const params = useExtraRequestParameters();

	const { data, error, isLoading } = useSWR(
		promotionId && settings?.storeId
			? [settings.storeId, promotionId, DATA_KEY_COUPON_STATUS]
			: null,
		async ([storeId, id]) => {
			const res = await transactionsCouponStatus(true).findCouponStatus(storeId, id, params);
			return res?.response;
		},
		{ revalidateOnFocus: false }
	);

	return {
		error,
		isLoading,
		shortDescription: data?.shortDescription,
		longDescription: data?.longDescription,
		promotionId: data?.promotionId,
	};
};
